import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "../../../shared/hooks/useHistory";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import Typography from "@material-ui/core/Typography";

import { StripeCustomerPortalButton } from "../StripeCustomerPortalButton/StripeCustomerPortalButton";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 200,
    width: 300,
  },
  dialog: {
    "& .MuiDialogActions-root": {
      display: "flex",
      alignItem: "center",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    "& .MuiDialogTitle-root": {
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
  },
  btn: {
    textTransform: "none",
    marginRight: theme.spacing(1),
  },
  top: {
    textAlign: "center",
  },
  large: {
    fontSize: 60,
  },
  dialogActions: {
    justifyContent: "center !important",
    marginBottom: theme.spacing(3),
  },
}));

export const InactiveSubscriptionDialog = ({
  open,
  onClose,
  participantProfileId,
  subscriptionStatus,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNewSusbscription = () => {
    onClose();
    history.push("/enroll");
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        className={classes.dialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container style={{ justifyContent: "space-between" }}>
          <IconButton
            data-testid="dialog-icon-btn-close"
            name="errors"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <DialogContent>
          <Grid item lg={12} md={12} className={classes.top}>
            <CardMembershipIcon className={classes.large} />
          </Grid>
          <Grid item lg={12} md={12}>
            <Typography component="h5" variant="h5">
              You are not part of the Membership.
            </Typography>
          </Grid>
          <DialogContentText
            style={{ textAlign: "center" }}
            data-testid="alert-dialog-description"
            id="alert-dialog-description"
          >
            {subscriptionStatus !== "canceled"
              ? "Please, update your payment information."
              : "Please, enroll to continue with your membership."}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {subscriptionStatus !== "canceled" ? (
            <StripeCustomerPortalButton
              profileId={participantProfileId}
              text="Update Membership"
            />
          ) : (
            <Grid item>
              <Button
                color="primary"
                fullWidth
                variant="contained"
                onClick={handleNewSusbscription}
              >
                Enroll
              </Button>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

InactiveSubscriptionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  participantProfileId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  subscriptionStatus: PropTypes.string.isRequired,
};
